<template>
  <div id="app">
    <div class="clock">
      <span>{{hours}}</span>点<span>{{mins}}</span>分<span>{{secs}}</span>秒
    </div>
  </div>
</template>
<script>
import { setInterval } from 'timers';
export default {
  data:function(){
    return{
      hours:'',
      mins:'',
      secs:''
    }
  },
  methods:{
    getTimes(){
      var date=new Date();
      this.hours=this.format( date.getHours());
      this.mins=this.format(date.getMinutes());
      this.secs=this.format(date.getSeconds());
    },
    format(a){
      return a.toString().replace(/^(\d)$/,'0$1');
    }
  },
  created(){
    this.getTimes();
  },
  mounted(){
    setInterval(this.getTimes,1000);
  }
}
</script>
<style>
body,div{
  margin: 0;
  padding: 0;
}
body{
  color: #fff;
  font: 16px/1.5 \5fae\8f6f\96c5\9ed1;
}
.clock{
  width: 300px;
  text-align: center;
  background: #1a1a1a;
  margin: 10px auto;
  padding: 20px 0;
}
span{
  color: #000;
  width: 80px;
  line-height: 2;
  background: #fbfbfb;
  border: 2px solid #b4b4b4;
  margin: 0 10px;
  padding: 0 10px;
}
</style>
